import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'
import { ProductsState, ProductResource } from './products.types'

const mutations: MutationTree<ProductsState> = {
  SET_PRODUCTS (state, products: ProductResource[]) {
    Vue.set(state, 'data', {})

    products.forEach(product => Vue.set(state.data, product.id, product))
  },

  SET_PRODUCT (state, product: ProductResource) {
    Vue.set(state.data, product.id, product)
  }
}

export default mutations

